export const CHOICES_FROM_API_SELECTOR = '[data-choices-from-api]';

export function toRootRelativeUrl(url) {
  /**
   * The endpoint is stored root-relative but without a leading slash (e.g. "api/facility/"),
   * so it must be normalized here or the browser resolves it against the current page path
   * instead of the site root.
   */
  return url.startsWith('/') ? url : `/${url}`;
}

function formatChoiceFromApi(state) {
  /**
   * Display the option label plus, if requested via data-choices-from-api-display-properties,
   * any extra metadata returned alongside it by the API (e.g. a facility's address).
   */
  if (!state.id) {
    return state.text;
  }

  const extraProperties = ($(state.element).closest('select').data('choices-from-api-display-properties') || '')
    .split(',')
    .filter(property => property && property !== 'label');
  const extraText = extraProperties.map(property => state[property]).filter(Boolean).join(' - ');

  if (!extraText) {
    return state.text;
  }
  return $(`<span>${state.text}</span><br><small class="text-muted">${extraText}</small>`);
}

function initializeChoicesFromApiSelect2(select) {
  /**
   * Populate a select via AJAX search against the API endpoint given in data-choices-from-api.
   * The search term is sent under the query param matching the endpoint's last path segment
   * (e.g. "api/facility/" -> "?facility=<term>"), matching the corresponding view's expected param name.
   */
  const apiUrl = toRootRelativeUrl($(select).data('choices-from-api'));
  const searchParam = apiUrl.replace(/\/+$/, '').split('/').pop();

  $(select).select2({
    theme: 'bootstrap',
    width: '100%',
    minimumInputLength: 1,
    ajax: {
      url: apiUrl,
      dataType: 'json',
      delay: 350,
      cache: true,
      data: params => ({ [searchParam]: params.term }),
      processResults: data => ({
        results: data.map(item => ({ ...item, id: item.value, text: item.label })),
      }),
    },
    templateResult: formatChoiceFromApi,
    templateSelection: formatChoiceFromApi,
  });
}

export function initializeChoicesFromApiSelects() {
  $(CHOICES_FROM_API_SELECTOR).each(function initializeChoicesFromApi() {
    initializeChoicesFromApiSelect2(this);
  });
}
